import { SUBROUTES } from '../../App'

export const SET_SEARCH_EDGE = 'SET_SEARCH_EDGE'
export const INIT_SEARCH_VALUE_CACHE_AND_STALES = 'INIT_SEARCH_VALUE_CACHE_AND_STALES'

const initialState = {
  results: null,
  templates: {},
  edges: {},
  descriptions: {},
  searching: false,
  selected: {},
  selectedDetails: null,
  sorts: {},
  resultsMode: 'table',
  recordDetailsLoading: false,
  userOwnsSelectedRecord: null,
  selectedRecordHasOwners: null,
  activeCategory: null,
  searchValueCache: {},
  searchError: {},
  stales: {},
}

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case '@@SEARCH_RESET_STATE':
      return initialState
    case '@@SEARCH_SET_RESULTS':
      return {
        ...state,
        results: { ...state.results, [action.category]: action.results.rows },
        templates: { ...state.templates, [action.category]: action.results.template },
        searchValueCache: { ...state.searchValueCache, [action.category]: action.searchValue },
        edges: {
          ...state.edges,
          [action.category]: {
            ...action.results.edge,
            PageNum: action.results.edge
              ? action.results.edge.PageNum
              : state.edges[action.category].PageNum,
            PageSize: action.results.edge
              ? action.results.edge.PageSize
              : state.edges[action.category].PageSize,
            TotalRows: action.results.edge
              ? action.results.edge.TotalRows
              : state.edges[action.category].TotalRows,
          },
        },
        stales: { ...state.stales, [action.category]: false },
      }
    case '@@SEARCH_SET_ACTIVE_CATEGORY':
      return {
        ...state,
        activeCategory: action.category,
      }
    case '@@SEARCH_SELECT_ROW':
      return {
        ...state,
        selected: {
          ...state.selected,
          [action.category]:
            state.selected[action.category] !== action.recordId ? action.recordId : null,
        },
      }
    case '@@SEARCH_SET_SELECTED_DETAILS':
      return { ...state, selectedDetails: action.details }
    case '@@SEARCH_SET_RESULTS_MODE':
      return { ...state, resultsMode: action.mode }
    case '@@SEARCH_TOGGLE_SEARCHING':
      return { ...state, searching: action.searching }
    case '@@SEARCH_SET_SELECTED_OWNERSHIP_RECORDS':
      return { ...state, selectedOwnershipRecords: action.selectedOwnershipRecords }
    case '@@SEARCH_SET_RECORD_DETAILS_LOADING':
      return { ...state, recordDetailsLoading: action.loading }
    case '@@SEARCH_SET_USER_OWNS_SELECTED_RECORD':
      return { ...state, userOwnsSelectedRecord: action.isOwner }
    case '@@SEARCH_SET_SELECTED_RECORD_HAS_OWNERS':
      return { ...state, selectedRecordHasOwners: action.hasOwners }
    case '@@SEARCH_SET_SORT':
      return {
        ...state,
        sorts: {
          ...state.sorts,
          [action.category]: { sortBy: action.sortBy, sortByDirection: action.sortByDirection },
        },
        edges: {
          ...state.edges,
          [action.category]: { ...state.edges[action.category], pageNum: 1 },
        },
      }
    case '@@SEARCH_SET_DESCRIPTION':
      return {
        ...state,
        descriptions: { ...state.descriptions, [action.category]: action.description },
      }
    case '@@SEARCH_SET_SEARCH_ERROR': {
      const { [action.category]: deletedResults, ...results } = state.results || {}
      const { [action.category]: deletedTemplates, ...templates } = state.templates
      const { [action.category]: deletedSearchValueCache, ...searchValueCache } =
        state.searchValueCache
      const { [action.category]: deletedEdges, ...edges } = state.edges
      return {
        ...state,
        searchError: { ...state.searchError, [action.category]: action.searchError },
        results,
        templates,
        searchValueCache,
        edges,
      }
    }
    case '@@SEARCH_CLEAR_SEARCH_ERROR':
      return { ...state, searchError: { ...state.searchError, [action.category]: null } }
    case '@@SEARCH_INVALIDATE_CACHE':
      return {
        ...state,
        stales: Object.keys(state.stales).reduce((obj, key) => {
          obj[key] = true
          return obj
        }, {}),
        selected: {},
      }
    case SET_SEARCH_EDGE:
      const { category, PageSize, PageNum, TotalRows } = action
      return {
        ...state,
        edges: {
          ...state.edges,
          [category]: {
            PageSize: PageSize || 10,
            PageNum: PageNum || 1,
            TotalRows: TotalRows || 20,
          },
        },
      }
    case INIT_SEARCH_VALUE_CACHE_AND_STALES:
      return {
        ...state,
        searchValueCache:
          Object.keys(state.searchValueCache).length === 0
            ? SUBROUTES.filter(
                (s) => s.PublicSearchSettings && s.PublicSearchSettings.Enabled
              ).reduce((obj, r) => ({ ...obj, [r.parameter]: '' }), {})
            : state.searchValueCache,
        stales:
          Object.keys(state.stales).length === 0
            ? SUBROUTES.filter(
                (s) => s.PublicSearchSettings && s.PublicSearchSettings.Enabled
              ).reduce((obj, r) => ({ ...obj, [r.parameter]: false }), {})
            : state.stales,
      }
    default:
      return state
  }
}

export default searchReducer
